import { type ReactElement } from 'react'
import { Stack, Text } from '@mantine/core'
import { NotReady } from '@components'
import { useHasRelevantQuarterlyPlan } from '../useHasRelevantQuarterlyPlan'

export function GoalWidget(): ReactElement {
  const { hasRelevantQuarterlyPlan, isLoading } = useHasRelevantQuarterlyPlan()

  if (isLoading) return <NotReady inline id='Quarterly Plan' isLoading={isLoading} />

  if (hasRelevantQuarterlyPlan) {
    return (
      <Stack gap={4} justify='center' className='min-h-[120px]'>
        <Text fw={600}>Controlled by Quarterly Plans</Text>
        <Text c='dimmed' size='sm'>
          This widget uses the quarterly plan configured in the mobile app.
        </Text>
      </Stack>
    )
  }

  return (
    <Stack gap={4} justify='center' className='min-h-[120px]'>
      <Text fw={600}>Set Up Quarterly Plan on Mobile</Text>
      <Text c='dimmed' size='sm'>
        Open the mobile app to set up your quarterly plan. Once it is set up, this widget will show your goal progress
        here.
      </Text>
    </Stack>
  )
}
